// extracted by mini-css-extract-plugin
export var button = "_cv-0";
export var icon = "_cv-1";